var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7786 3.96587C17.0123 2.91162 16.0319 1.96033 14.9704 2.26752L3.22803 5.68433L3.11471 5.722C2.01252 6.1368 1.84341 7.67186 2.87576 8.30739L7.73241 11.2968L10.6542 16.1373L10.7199 16.2373C11.4048 17.1969 12.9215 16.9645 13.2673 15.8012L16.7512 4.0716L16.7786 3.96587ZM15.3386 3.33714C15.5552 3.31388 15.7403 3.52455 15.6728 3.75076L12.1889 15.4808L12.166 15.5383C12.0571 15.7524 11.7491 15.7742 11.6174 15.556L8.85139 10.9743L12.7908 7.00953L12.845 6.94626C13.0077 6.72551 12.9885 6.41307 12.7881 6.21404L12.7248 6.15978C12.5041 5.99713 12.1917 6.01632 11.9926 6.21669L8.05864 10.1763L3.46546 7.34934L3.41587 7.3121C3.23749 7.14961 3.29753 6.83557 3.54196 6.76463L15.2839 3.34795L15.3386 3.33714Z",
    fill: "#8083A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.2a3e9f1c.svg";
export { ForwardRef as ReactComponent };